import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { getBankByName } from '@src/api'
import {
  DefaultApiGetBankByNameRequest,
  GetBankByName200Response,
} from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'
import { CustomError } from '@src/types'

export const useFetchBankByName = (params: DefaultApiGetBankByNameRequest) => {
  const { axiosInstance } = useAxios()

  return useQuery<
    AxiosResponse<GetBankByName200Response>,
    AxiosResponse<CustomError>
  >({
    enabled: false,
    queryFn: () => getBankByName(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_BANK_BY_NAME, params],
  })
}
